import BOMViewStore from "./BOMViewStore";

const bomStoreList = [
  { name: "bomViewStore", store: BOMViewStore },
];

export default bomStoreList;